var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  File View\n  "),_c('iframe',{attrs:{"src":_vm.filepath,"width":"100%","height":"600"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }